module.exports = __webpack_public_path__ + "fonts/F37GingerPro-Light.873a895.woff2";